
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'FilterDetails',
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        required: true,
      },
      hasValue: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:isOpen'],
    computed: {
      // writable computed: читает проп, а при изменении эмитит update:isOpen (для v-model:isOpen).
      isOpenModel: {
        get(): boolean {
          return this.isOpen;
        },
        set(value: boolean) {
          this.$emit('update:isOpen', value);
        },
      },
    },
  });
